import React from 'react';
import {Box, MenuItem, Select} from "@mui/material";
import {useTypedSelector} from "../../hooks/useTypeSelector";
import {StoreShelfStyleDto, StoreShelfStylesDto} from "../../dtos";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface Props {
    onChange: (value: number) => void;
    shelfStyleId: number;
}

const StoreShelfStylesSelect: React.FC<Props> = ({
                                                     onChange,
                                                     shelfStyleId
                                                 }) => {
    const storeShelfStyles: StoreShelfStylesDto = useTypedSelector((state) => state.storeShelfStyles)

    const onChangeShelfStyle = (item: any) => {
        if (onChange) {
            onChange!(Number(item.target.value));
        }
    };


    const frameTypeSelectOptions = storeShelfStyles.storeShelfStyles.map((shelfStyle: StoreShelfStyleDto) => {
        return (
            <MenuItem value={shelfStyle.id} key={shelfStyle.id} sx={{
                padding: `12px 32px 12px 8px`,
            }}>
                <Box sx={{
                    display: `flex`,
                    alignItems: `center`,
                    height: "24px",
                    width: "100%"
                }}>

                    {
                        shelfStyle.textureImageUrl &&
                        <Box
                            sx={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                flexFlow: "column"
                            }}
                        >
                            <Box
                                sx={{
                                    width: "100%",
                                    height: "49%",
                                    backgroundImage: `url(${shelfStyle.textureImageUrl})`,
                                    backgroundSize: "cover",
                                    clipPath: "polygon(10% 0, 90% 0, 100% 102%, 0% 102%)",
                                    opacity: "0.8"
                                }}
                            >
                            </Box>
                            <Box
                                sx={{
                                    width: "100%",
                                    height: "51%",
                                    backgroundImage: `url(${shelfStyle.textureImageUrl})`,
                                    backgroundSize: "cover",
                                }}
                            >
                            </Box>
                        </Box>
                    }
                    {
                        !shelfStyle.textureImageUrl &&

                        <Box
                            sx={{
                                width: "100%",
                                height: "100%"
                            }}
                        >
                            <Box
                                sx={{
                                    width: "100%",
                                    height: "50%",
                                    borderBottom: `12px solid ${shelfStyle.colorRgb || "red"}80`,
                                    borderLeft: "30px solid transparent",
                                    borderRight: "30px solid transparent",
                                }}
                            >
                            </Box>
                            <Box
                                sx={{
                                    width: "100%",
                                    height: "50%",
                                    backgroundColor: `${shelfStyle.colorRgb || "red"}`
                                }}
                            >
                            </Box>
                        </Box>
                    }
                </Box>
            </MenuItem>

        )
    })

    return (
        <Select
            displayEmpty
            value={shelfStyleId}
            onChange={onChangeShelfStyle}
            inputProps={{'aria-label': 'Without label'}}
            IconComponent={KeyboardArrowDownIcon}
            sx={{
                width: `100%`,
                // height: `38px`,
                border: `1px solid #d1d7db`,
                '& legend': {display: 'none'},
                '& fieldset': {
                    top: 0,
                    border: `none`,
                },
                '& > .MuiSelect-select': {
                    padding: `12px 8px`
                }
            }}
            MenuProps={{
                PaperProps: {
                    sx: {
                        "& .MuiMenuItem-root.Mui-selected": {
                            backgroundColor: "#C7C6C1!important",
                            '& .MuiTypography-root': {
                                color: `#ffffff`,
                            }
                        },
                        "& .MuiMenuItem-root:hover": {
                            backgroundColor: "#999DA0",
                            '& .MuiTypography-root': {
                                color: `#ffffff`,
                            }
                        },
                        "& .MuiMenuItem-root.Mui-selected:hover": {
                            backgroundColor: "#818380!important",
                            '& .MuiTypography-root': {
                                color: `#ffffff`,
                            }
                        }
                    }
                },
                MenuListProps: {
                    sx: {
                        padding: "4px 0",
                    }
                }
            }}
        >
            {frameTypeSelectOptions}
        </Select>
    )
}

export default StoreShelfStylesSelect;